import React, { lazy } from "react";

//material UI
import { Grid, Typography } from "@mui/material";

//imagens
import MyGenderLogo from "../../images/mygender-logo__small.svg";

import ContactLogo from "../../images/contact-logo.svg";
import CreditsLogo from "../../images/credits-logo.svg";
import { Link } from "react-router-dom";

//components
const CustomButton = lazy(() => import("../../components/Button"));

export default function ContactScreen() {
  return (
    <Grid container spacing={2} sx={{ minHeight: "100vh" }}>
      <Grid item xs></Grid>
      <Grid item xs={10} zeroMinWidth>
        <Grid
          container
          spacing={2}
          sx={{
            marginBottom: {
              xs: "25%",
              sm: "15%",
              md: "10%",
              lg: "5%",
              xl: "5%",
            },
          }}
        >
          <Grid item xs={12} sx={{ textAlign: "right", marginTop: "6vh" }}>
            <img
              src={MyGenderLogo}
              className="mygender-logo__about"
              alt="Logo oficial do projeto de investigação MyGender da Universidade de Coimbra"
            ></img>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={2} sx={{ textAlign: "right" }}>
                <img
                  alt="Icon com um balão de mensagem com tres pontos no interior"
                  src={ContactLogo}
                />
              </Grid>
              <Grid item xs={10}>
                <Typography
                  color={"#000000"}
                  fontSize={{
                    xs: "2rem",
                    sm: "2rem",
                    md: "2rem",
                    lg: "3rem",
                    xl: "3rem",
                  }}
                  fontStyle={"normal"}
                  fontWeight={700}
                  fontFamily={"Inter, Helvetica, sans-serif"}
                  lineHeight={"100%"}
                >
                  Contato
                </Typography>
                <Typography
                  color={"#000000"}
                  fontSize={{
                    xs: "1rem",
                    sm: "1rem",
                    md: "1rem",
                    lg: "1.25rem",
                    xl: "1.25rem",
                  }}
                  fontStyle={"normal"}
                  fontWeight={400}
                  fontFamily={"Helvetica Neue, Inter, Helvetica, sans-serif"}
                  lineHeight={"114%"}
                >
                  Tens alguma sugestão? Escreva-nos!
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ textAlign: "center", marginTop: "2.577873254564984vh" }}
          >
            <Typography
              color={"#000000"}
              letterSpacing={0}
              fontSize={{
                xs: "1.5rem",
                sm: "1.5rem",
                md: "1.5rem",
                lg: "2rem",
                xl: "2rem",
              }}
              fontWeight={700}
              fontFamily={"Inter, Helvetica, sans-serif"}
              textAlign={"center"}
            >
              mygender@fl.uc.pt
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              textAlign: "center",
            }}
          >
            <Link to={"https://mygender.uc.pt/pt_PT/"}>
              <CustomButton
                type={"Link"}
                width={[
                  {
                    xs: "64px",
                    sm: "64px",
                    md: "64px",
                    lg: "74px",
                    xl: "74px",
                  },
                ]}
                height={"50px"}
                backcolor={"#EDE838"}
                marginRight={"5px"}
                desc={"Visite o website oficial do projeto MyGender da UC"}
              ></CustomButton>
            </Link>
            <Link to={"https://www.instagram.com/mygender_"}>
              <CustomButton
                type={"Instagram"}
                width={[
                  {
                    xs: "64px",
                    sm: "64px",
                    md: "64px",
                    lg: "74px",
                    xl: "74px",
                  },
                ]}
                height={"50px"}
                backcolor={"#EDE838"}
                marginRight={"5px"}
                desc={
                  "Visite a página oficial do projeto MyGender no Instragram"
                }
              ></CustomButton>
            </Link>
            <Link to={"https://www.facebook.com/mygender"}>
              <CustomButton
                type={"Facebook"}
                width={[
                  {
                    xs: "64px",
                    sm: "64px",
                    md: "64px",
                    lg: "74px",
                    xl: "74px",
                  },
                ]}
                height={"50px"}
                backcolor={"#EDE838"}
                marginRight={"5px"}
                desc={"Visite a página oficial do projeto MyGender no Facebook"}
              ></CustomButton>
            </Link>
            <Link to={"https://twitter.com/mygender_"}>
              <img
                src={process.env.PUBLIC_URL + "/images/twitter-x.svg"}
                width={[
                  {
                    xs: "64px",
                    sm: "64px",
                    md: "64px",
                    lg: "74px",
                    xl: "74px",
                  },
                ]}
                height={"50px"}
                alt="Visite o perfil oficial do projeto MyGender no X (ex Twitter)"
                style={{
                  boxSizing: "border-box",
                  verticalAlign: "middle",
                  backgroundColor: "#EDE837",
                  color: "#000000",
                  border: "5px solid #000000",
                  borderRadius: "57px",
                  borderWidth: "thick",
                }}
              ></img>
            </Link>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: "5vh" }}>
            <Grid container spacing={2}>
              <Grid item xs={2} sx={{ textAlign: "right" }}>
                <img alt="Icon com dois livros" src={CreditsLogo} />
              </Grid>
              <Grid
                item
                xs={10}
                display="flex"
                justifyContent="start"
                alignItems="center"
              >
                <Typography
                  color={"#000000"}
                  fontSize={{
                    xs: "2rem",
                    sm: "2rem",
                    md: "2rem",
                    lg: "3rem",
                    xl: "3rem",
                  }}
                  fontStyle={"normal"}
                  fontWeight={700}
                  fontFamily={"Inter, Helvetica, sans-serif"}
                  lineHeight={"100%"}
                >
                  Créditos da App
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ marginLeft: "15vw" }}>
            <Typography
              color={"#000000"}
              fontSize={{
                xs: "1.25rem",
                sm: "1.25rem",
                md: "1.25rem",
                lg: "1.5rem",
                xl: "1.5rem",
              }}
              fontStyle={"normal"}
              fontWeight={600}
              fontFamily={"Helvetica Neue, Inter, Helvetica, sans-serif"}
              lineHeight={"114%"}
            >
              Conceito
            </Typography>
            <Typography
              color={"#000000"}
              fontSize={{
                xs: "1rem",
                sm: "1rem",
                md: "1rem",
                lg: "1.25rem",
                xl: "1.25rem",
              }}
              fontStyle={"normal"}
              fontWeight={400}
              fontFamily={"Helvetica Neue, Inter, Helvetica, sans-serif"}
              lineHeight={{
                xs: "1.25rem",
                sm: "1.25rem",
                md: "1.25rem",
                lg: "1.75rem",
                xl: "1.75rem",
              }}
              textTransform={"uppercase"}
            >
              Inês Amaral
              <br />
              Rita Basílio de Simões
              <br />
              Eduardo Antunes
              <br />
              Ana Marta M. Flores
              <br />
              <br />
            </Typography>
            <Typography
              color={"#000000"}
              fontSize={{
                xs: "1.25rem",
                sm: "1.25rem",
                md: "1.25rem",
                lg: "1.5rem",
                xl: "1.5rem",
              }}
              fontStyle={"normal"}
              fontWeight={600}
              fontFamily={"Helvetica Neue, Inter, Helvetica, sans-serif"}
              lineHeight={"114%"}
            >
              Pesquisa e Perguntas
              <br />
            </Typography>
            <Typography
              color={"#000000"}
              fontSize={{
                xs: "1rem",
                sm: "1rem",
                md: "1rem",
                lg: "1.25rem",
                xl: "1.25rem",
              }}
              fontStyle={"normal"}
              fontWeight={400}
              fontFamily={"Helvetica Neue, Inter, Helvetica, sans-serif"}
              lineHeight={{
                xs: "1.25rem",
                sm: "1.25rem",
                md: "1.25rem",
                lg: "1.75rem",
                xl: "1.75rem",
              }}
              textTransform={"uppercase"}
            >
              EDUARDO ANTUNES
              <br />
              <br />
            </Typography>
            <Typography
              color={"#000000"}
              fontSize={{
                xs: "1.25rem",
                sm: "1.25rem",
                md: "1.25rem",
                lg: "1.5rem",
                xl: "1.5rem",
              }}
              fontStyle={"normal"}
              fontWeight={600}
              fontFamily={"Helvetica Neue, Inter, Helvetica, sans-serif"}
              lineHeight={"114%"}
            >
              Design Gráfico
            </Typography>
            <Typography
              color={"#000000"}
              fontSize={{
                xs: "1rem",
                sm: "1rem",
                md: "1rem",
                lg: "1.25rem",
                xl: "1.25rem",
              }}
              fontStyle={"normal"}
              fontWeight={400}
              fontFamily={"Helvetica Neue, Inter, Helvetica, sans-serif"}
              lineHeight={{
                xs: "1.25rem",
                sm: "1.25rem",
                md: "1.25rem",
                lg: "1.75rem",
                xl: "1.75rem",
              }}
              textTransform={"uppercase"}
            >
              Ana Marta M. Flores
              <br />
              <br />
            </Typography>
            <Typography
              color={"#000000"}
              fontSize={{
                xs: "1.25rem",
                sm: "1.25rem",
                md: "1.25rem",
                lg: "1.5rem",
                xl: "1.5rem",
              }}
              fontStyle={"normal"}
              fontWeight={600}
              fontFamily={"Helvetica Neue, Inter, Helvetica, sans-serif"}
              lineHeight={"114%"}
            >
              Ilustrações
            </Typography>
            <Typography
              color={"#000000"}
              fontSize={{
                xs: "1rem",
                sm: "1rem",
                md: "1rem",
                lg: "1.25rem",
                xl: "1.25rem",
              }}
              fontStyle={"normal"}
              fontWeight={400}
              fontFamily={"Helvetica Neue, Inter, Helvetica, sans-serif"}
              lineHeight={{
                xs: "1.25rem",
                sm: "1.25rem",
                md: "1.25rem",
                lg: "1.75rem",
                xl: "1.75rem",
              }}
              textTransform={"uppercase"}
            >
              <Link to="https://storyset.com">Storyset</Link> /{" "}
              <Link to="https://www.freepik.com">Freepik</Link>
              <br />
              <br />
            </Typography>
            <Typography
              color={"#000000"}
              fontSize={{
                xs: "1.25rem",
                sm: "1.25rem",
                md: "1.25rem",
                lg: "1.5rem",
                xl: "1.5rem",
              }}
              fontStyle={"normal"}
              fontWeight={600}
              fontFamily={"Helvetica Neue, Inter, Helvetica, sans-serif"}
              lineHeight={"114%"}
            >
              Programação e Desenvolvimento
            </Typography>
            <Typography
              color={"#000000"}
              fontSize={{
                xs: "1rem",
                sm: "1rem",
                md: "1rem",
                lg: "1.25rem",
                xl: "1.25rem",
              }}
              fontStyle={"normal"}
              fontWeight={400}
              fontFamily={"Helvetica Neue, Inter, Helvetica, sans-serif"}
              lineHeight={{
                xs: "1.25rem",
                sm: "1.25rem",
                md: "1.25rem",
                lg: "1.75rem",
                xl: "1.75rem",
              }}
              textTransform={"uppercase"}
            >
              FREDERICO FONSECA
              <br />
              <br />
            </Typography>
            <Typography
              color={"#000000"}
              fontSize={{
                xs: "1.25rem",
                sm: "1.25rem",
                md: "1.25rem",
                lg: "1.5rem",
                xl: "1.5rem",
              }}
              fontStyle={"normal"}
              fontWeight={600}
              fontFamily={"Helvetica Neue, Inter, Helvetica, sans-serif"}
              lineHeight={"114%"}
            >
              Financiamento
            </Typography>
            <Typography
              color={"#000000"}
              fontSize={{
                xs: "1rem",
                sm: "1rem",
                md: "1rem",
                lg: "1.25rem",
                xl: "1.25rem",
              }}
              fontStyle={"normal"}
              fontWeight={400}
              fontFamily={"Helvetica Neue, Inter, Helvetica, sans-serif"}
              lineHeight={{
                xs: "1.25rem",
                sm: "1.25rem",
                md: "1.25rem",
                lg: "1.75rem",
                xl: "1.75rem",
              }}
              textTransform={"uppercase"}
            >
              Fundação para a Ciência e a Tecnologia PTDC/COM-CSS/5947/2020.
              <br />
              <br />
            </Typography>
            <Typography
              color={"#000000"}
              fontSize={{
                xs: "1rem",
                sm: "1rem",
                md: "1rem",
                lg: "1.25rem",
                xl: "1.25rem",
              }}
              fontStyle={"normal"}
              fontWeight={600}
              fontFamily={"Helvetica Neue, Inter, Helvetica, sans-serif"}
              lineHeight={{
                xs: "1.25rem",
                sm: "1.25rem",
                md: "1.25rem",
                lg: "1.75rem",
                xl: "1.75rem",
              }}
            >
              SETEMBRO 2023
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs></Grid>
    </Grid>
  );
}
